export default {
	resultFileList_({ fileList }) {
		return fileList;
	}
};
